<template>
  <div class="controlOrder">
    <div class="title">设置控制价审核信息</div>
    <el-form
      ref="ruleForm"
      :model="formData"
      label-width="130px"
      :inline="true"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="日期">
            <el-date-picker
              v-model="formData.approveTime"
              type="date"
              placeholder="请选择日期"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称">
            <el-input v-model="formData.projectName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提报单位/部门">
            <el-input v-model="formData.commitDeptName" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购计划事项">
            <el-input v-model="formData.bidPlanItem" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采购计划编号" prop="controlPriceId">
            <el-input v-model="formData.bidPlanCode" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目类别">
            <el-input v-model="formData.projectType" readonly></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="采购金额">
            <el-input v-model="formData.estimatePrice" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购方式：">
            <el-input v-model="formData.bidPlanMethodValue" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否已取得决策依据">
            <el-input
              v-model="formData.decisionBaseDisplayName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 20px">
        <el-col :span="24">
          <el-form-item label="审核内容" prop="approveComment">
            <el-input
              type="textarea"
              v-model="formData.approveComment"
              :rows="3"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="审核金额" prop="approvePrice">
            <el-input
              type="textarea"
              v-model="formData.approvePrice"
              :rows="3"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="formData.approveInfoList">
      <div class="title">审批人及打印设置</div>

      <template v-for="(item, index) in formData.approveInfoList">
        <el-row :key="item.id" class="approveItem">
          <!-- <el-col :span="4">
            <el-form-item
              v-if="index == 0"
              label="参会部门及其负责人"
              prop="serialNumber"
            >
            </el-form-item>
            <el-form-item v-else label="" prop="serialNumber"> </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item
              :label="`审批人${index + 1}`"
              label-width="130px"
              prop="serialNumber"
            >
              <el-input v-model="item.approveUserName" readonly=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" style="margin-left: 10px">
            <el-input v-model="item.jobName"></el-input>
          </el-col>
          <el-col :span="3">
            <div class="checkboxWrap">
              <el-checkbox v-model="item.isPrint" style="width: 40px" label="1"
                >打印
              </el-checkbox>
            </div>
          </el-col>
          <el-col :span="5" style="margin-left: 10px">
            <el-select
              v-model="item.opinionKey"
              filterable
              default-first-option
              placeholder="请选择"
              @change="changeType(index)"
            >
              <el-option
                v-for="em in typeOptions"
                :key="em.label"
                :label="em.value"
                :value="em.label"
              ></el-option>
            </el-select>
            <!-- <el-option label="定额工作小组成员意见" value="1"></el-option>
              <el-option label="定额工作小组副组长意见" value="2"></el-option>
              <el-option label="定额工作小组组长意见" value="3"></el-option>
            </el-select> -->
          </el-col>
          <!-- <el-col :span="4" style="margin-top: 24px">
            <div class="checkboxWrap">
              <el-checkbox
                v-model="item.opinionKey"
                style="width: 40px"
                label="1"
                >集团分管领导意见
              </el-checkbox>
            </div>
          </el-col> -->
        </el-row>
      </template>
      </div>
    </el-form>
    <div class="bottomBtn">
      <el-button type="primary" @click="print">打印预览</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <priceOrderPrint
      :visible.sync="printVisible"
      :printData="formData"
      v-if="printVisible"
    >
    </priceOrderPrint>
  </div>
</template>

<script>
import {
  getcontrolPricedetail, //获取一条采购计划信息
  updatecontrolPricePrint,
} from "@/services/bidServices";
import { getsysDictDetailApi, getsignUrlApi} from "@/services/sysSettingService";
import {
  queryRealApproveProcessSign, //获取打印页面带签名审批详情
} from "@/services/approveServices";
import priceOrderPrint from "./priceOrderPrint";
// import DeptSelectComponent from "./DeptSelectComponent";
// import PrintDeptSelectComponent from "./PrintDeptSelectComponent";

export default {
  name: "controlOrder",
  props: {
    itemId: {
      type: Number,
    },
    approveType: {
      type: String,
    },
  },
  components: {
    priceOrderPrint,
    // DeptSelectComponent,
    // PrintDeptSelectComponent,
  },
  data() {
    return {
      formData: {
        title: "定额工作小组审核确认单",
        approveTime: new Date(),
        projectName: "",
      },
      typeOptions: [],
      printVisible: false,
    };
  },
  watch: {
    itemId: {
      handler: function (newVal) {
        if (newVal) {
          this.getDetail(this.itemId);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getOptionType();
  },
  methods: {
    //获取一条信息
    getDetail(id) {
      getcontrolPricedetail({ bidPriceId: id })
        .then((res) => {
          if (res.code == 10000000) {
            const data = res.data || {};
            data.title = data.title ?? "定额工作小组审核确认单";

            // data.approveTime = data.approveTime ? new Date(data.approveTime) : new Date();
            this.formData = data;

            if (!res.data.approveInfoList) {
              queryRealApproveProcessSign({
                itemId: id,
                approveClass: "BID_PRICE_CONTROLE",
              }).then((res1) => {
                if (res1.code == 10000000) {
                  const approveInfoList = res1.data || [];
                  console.log(data.approvePassTime)
                  console.log(Date.parse(data.approvePassTime))
                  console.log(new Date(Date.parse(data.approvePassTime)))
                   data.approveTime = data.approveTime ? new Date(data.approveTime) :new Date(data.approvePassTime||approveInfoList[approveInfoList.length-1].updateTime);
                  //  this.formData.approveTime= data.approveTime ? new Date(data.approveTime) :new Date(approveInfoList[approveInfoList.length-1].updateTime)
                  if (approveInfoList.length > 0) {
                    this.formData.approveInfoList = approveInfoList.map(
                      (item) => {
                        item.isPrint = true;
                        item.opinionKey = "";
                        item.opinionValue = "";
                        return item
                      }
                    );
                  }
                }
              });
            } else {
              this.formData.approveInfoList = data?.approveInfoList || [];
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    //获取项目部下拉列表数据
    getOptionType() {
      let reqParam = {
        key: "bidPricePrint",
      };
      getsysDictDetailApi(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOptions = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //获取审批人签名
    getsignUrlFun() {
      let reqParam = {
        signUserIdSet: this.formData.approveInfoList.map(item=>item.approveUserId).join(','),
      };
      getsignUrlApi(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            let urls=res.data
            this.formData.approveInfoList.forEach(em => {
              let s=urls.find(item=>item.userId==em.approveUserId)
              em.approveUserNameSignUrl=s.signUrl
              return em
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    submit() {
      let newOj = {
        approveTime: this.formData.approveTime,
        bidPriceId: this.itemId,
        title: this.formData.title,
      };
      newOj.approveInfoList = this.formData.approveInfoList;
      updatecontrolPricePrint({
        ...newOj
      })
        .then((res) => {
          if (res.code == 10000000) {
            this.$alert("保存成功", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert(res.msg, "确定");
          }
        })
        .catch((err) => {
          this.$message.error("网络请求失败");
        });
    },
    async print() {
      await this.getsignUrlFun()
      this.printVisible = true;
      this.$emit("handlePrint", {
        formData: this.formData,
        approveList: this.approveList,
      });
    },

    //切换审批人分组
    changeType(i) {
      let index = this.typeOptions.findIndex(
        (item) => item.label === this.formData.approveInfoList[i].opinionKey
      );
      if (index !== -1) {
        // this.ruleForm.typeKey = this.typeOption[index].label;
        this.formData.approveInfoList[i].opinionValue =
          this.typeOptions[index].value;
      }
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.controlOrder {
  margin-bottom: 30px;
  .title {
    margin: 10px 0;
    font-weight: bold;
  }

  .marginLeft8 {
    margin-top: 18px;
    margin-left: 4px;
  }

  .checkboxWrap {
    width: 110px - 12px;
    text-align: left;
    margin-left: 10px;
  }

  .bottomBtn {
    z-index: 100;
    left: 660px;
    position: fixed;
    bottom: 20px;
    height: 40px;
    line-height: 40px;
  }
}

/deep/ .el-form-item__content {
  width: 100%;
  .el-input {
    width: 100%;
  }
}
</style>
